module.exports = __webpack_public_path__ + "static/NewBaskervilleStd-Bold-dd0e106cefde68bb529554728c28f5ea.woff";